import React, { useEffect, useState } from "react";
import VideoPopup from "./VideoPopup";
import "./Videos.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "./Loader";
import API from "../constants/apiConfig";

const VideosPage = ({ videoIndex }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const [videos, setVideos] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(videoIndex || 0);
  const [popupVisible, setPopupVisible] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }

    const fetchVideosData = async () => {
      try {
        const response = await fetch(API.GET_VIDEOS, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            arkv: "!$Learn#$!",
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setVideos(data.data);
        console.log("videos data api called", data.data);

        const initialVideoUrl = location.state?.video_url;
        if (initialVideoUrl) {
          const index = data.data.findIndex(
            (video) => video.video_url === initialVideoUrl
          );
          if (index !== -1) {
            setCurrentVideoIndex(index);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchVideosData();
  }, [user, location.state]);

  const loadVideo = (videoUrl, index) => {
    setCurrentVideoIndex(index);
    setPopupVisible(false);

    const videoPlayer = document.getElementById("videoPlayer");
    if (videoPlayer) {
      videoPlayer.src = videoUrl;
      videoPlayer.load();
      videoPlayer.play();
    }
  };

  const handleVideoEnd = () => {
    setPopupVisible(true);
  };

  if (pageLoading) return <Loader />;

  return (
    <div>
      <div className="video-container">
        {videos.length > 0 && (
          <video
            id="videoPlayer"
            controls
            disablePictureInPicture
            controlsList="nofullscreen"
            onEnded={handleVideoEnd}
          >
            <source
              src={
                location.state?.video_url ||
                videos[currentVideoIndex]?.video_url
              }
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        )}
      </div>

      {popupVisible && (
        <VideoPopup
          videos={videos}
          currentVideoIndex={currentVideoIndex}
          loadVideo={loadVideo}
          closePopup={() => setPopupVisible(false)}
        />
      )}
    </div>
  );
};

export default VideosPage;
